(() => {
  const root=document.getElementById('SajustWelcomePopupRoot');
  if(!root||root.dataset.initialized==='true')return;

  const popup=root.querySelector('[data-sp-popup]');
  const form=root.querySelector('#SajustWelcomeNewsletterForm');
  const closeButton=root.querySelector('[data-sp-close]');
  const submitButton=root.querySelector('[data-sp-submit]');
  const submitText=root.querySelector('[data-sp-submit-text]');
  const status=root.querySelector('[data-sp-status]');
  const successBox=root.querySelector('[data-sp-success]');
  if(!popup||!form)return;

  root.dataset.initialized='true';

  const subscribedKey='sajust-welcome10-subscribed-v5';
  const dismissedKey='sajust-welcome10-dismissed-v5';
  const enteredKey='sajust-welcome10-entered-v5';
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let openedFromCart=false;
  let openedSurface='';
  let alreadySubscribed=false;
  let dismissed=false;

  try{
    alreadySubscribed=localStorage.getItem(subscribedKey)==='1';
    dismissed=sessionStorage.getItem(dismissedKey)==='1';
  }catch(_){}

  if(alreadySubscribed){
    document.documentElement.classList.add('sp-newsletter-subscribed');
    return;
  }

  if(root.dataset.spIneligible==='true'){
    document.documentElement.classList.add('sp-newsletter-ineligible');
    return;
  }

  let enteredAt=Date.now();
  try{
    const stored=Number(sessionStorage.getItem(enteredKey));
    if(stored>0)enteredAt=stored;
    else sessionStorage.setItem(enteredKey,String(enteredAt));
  }catch(_){}

  const remaining=Math.max(0,5000-(Date.now()-enteredAt));
  let showTimer=null;
  if(!dismissed)showTimer=window.setTimeout(()=>showPopup(false),remaining);

  function showPopup(force=false){
    if(force){
      if(showTimer)clearTimeout(showTimer);
      popup.getAnimations?.().forEach(a=>a.cancel());
      popup.classList.remove('is-closing','is-success-stage');
      successBox?.setAttribute('aria-hidden','true');
      status?.classList.remove('is-error');
      if(status)status.textContent='Pierakstoties, piekrīti saņemt jaunumus e-pastā.';
    }
    root.hidden=false;
    requestAnimationFrame(()=>requestAnimationFrame(()=>popup.classList.add('is-visible')));
  }

  function hidePopup(markDismissed=false){
    if(showTimer)clearTimeout(showTimer);
    if(markDismissed){
      try{sessionStorage.setItem(dismissedKey,'1')}catch(_){}
    }
    popup.classList.remove('is-visible');
    popup.classList.add('is-closing');
    setTimeout(()=>{root.hidden=true},reducedMotion?0:620);
  }

  closeButton?.addEventListener('click',()=>hidePopup(true));

  document.addEventListener('click',(event)=>{
    const trigger=event.target.closest?.('[data-sp-open-newsletter]');
    if(!trigger)return;
    event.preventDefault();

    openedFromCart=true;
    openedSurface=trigger.closest('cart-notification')?'notification':
      (trigger.closest('cart-drawer')?'drawer':'page');

    try{sessionStorage.removeItem(dismissedKey)}catch(_){}

    if(openedSurface==='drawer'){
      const drawer=document.querySelector('cart-drawer');
      if(drawer?.close)drawer.close();
    }else if(openedSurface==='notification'){
      const notification=document.querySelector('cart-notification');
      if(notification?.close)notification.close();
    }

    window.setTimeout(()=>showPopup(true),180);
  });

  function setBusy(busy){
    if(!submitButton)return;
    submitButton.disabled=busy;
    if(submitText)submitText.textContent=busy?'Piesakām…':'Pieteikties un saņemt atlaidi';
  }

  function setError(message){
    if(!status)return;
    status.textContent=message||'Neizdevās pieteikties. Mēģini vēlreiz.';
    status.classList.add('is-error');
  }

  const submitFrameName='SajustNewsletterSubmitFrame';
  let submitFrame=document.getElementById(submitFrameName);
  if(!submitFrame){
    submitFrame=document.createElement('iframe');
    submitFrame.id=submitFrameName;
    submitFrame.name=submitFrameName;
    submitFrame.hidden=true;
    submitFrame.setAttribute('aria-hidden','true');
    submitFrame.tabIndex=-1;
    document.body.appendChild(submitFrame);
  }
  form.setAttribute('target',submitFrameName);

  let newsletterSubmitting=false;

  function handleSubmit(event){
    status?.classList.remove('is-error');

    if(!form.reportValidity()){
      event.preventDefault();
      return;
    }

    newsletterSubmitting=true;
    setBusy(true);
    // Do not prevent the default submission: Shopify handles the customer form
    // normally, but the response is loaded into our hidden iframe instead of
    // navigating the storefront away from the current page.
  }

  form.addEventListener('submit',handleSubmit);

  submitFrame.addEventListener('load',()=>{
    if(!newsletterSubmitting)return;
    newsletterSubmitting=false;

    // Shopify has already finished processing the native customer form when
    // this frame loads. The response page is not reliable for frontend success
    // detection (it can omit our success marker even though the subscription
    // was actually saved), so completion of the native submission is treated
    // as success here.
    try{localStorage.setItem(subscribedKey,'1')}catch(_){}
    document.documentElement.classList.add('sp-newsletter-subscribed');

    refreshCartDrawer();
    runSuccessAnimation();
  });

  async function refreshCartDrawer(){
    try{
      const response=await fetch((window.routes?.cart_url||'/cart')+'?section_id=cart-drawer',{
        credentials:'same-origin',
        headers:{Accept:'text/html'}
      });
      if(!response.ok)return;

      const html=await response.text();
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.querySelector('#CartDrawer');
      const current=document.querySelector('#CartDrawer');
      if(fresh&&current)current.innerHTML=fresh.innerHTML;
    }catch(_){}
  }

  function runSuccessAnimation(){
    setBusy(false);
    popup.classList.add('is-success-stage');
    successBox?.setAttribute('aria-hidden','false');

    if(reducedMotion){
      setTimeout(()=>{
        root.hidden=true;
        pulseCart();
        reopenCartIfNeeded();
      },600);
      return;
    }

    setTimeout(()=>{
      const start=popup.getBoundingClientRect();

      popup.animate(
        [
          {transform:'translate3d(0,0,0) scale(1)',opacity:1},
          {transform:'translate3d(-70px,-42px,0) scale(.34)',opacity:.10}
        ],
        {duration:520,easing:'ease-in-out',fill:'forwards'}
      );

      const chip=document.createElement('div');
      chip.className='sp-fly-chip';
      chip.innerHTML=[
        '<span class="sp-success__check" aria-hidden="true">',
        '<svg viewBox="0 0 24 24"><path d="m6.5 12.5 3.3 3.2 7.7-8"></path></svg>',
        '</span>',
        '<span><strong>10% atlaide</strong><small>aktivizēta</small></span>'
      ].join('');
      chip.style.left=Math.round(start.left)+'px';
      chip.style.top=Math.round(start.top)+'px';
      document.body.appendChild(chip);

      chip.animate(
        [{opacity:0,transform:'scale(.78)'},{opacity:1,transform:'scale(1)'}],
        {duration:340,easing:'ease-out',fill:'forwards'}
      );

      setTimeout(()=>flyChipToCart(chip),430);
    },430);
  }

  function flyChipToCart(chip){
    const cart=document.querySelector('#cart-icon-bubble');

    if(!cart){
      chip.animate([{opacity:1},{opacity:0}],{duration:360,fill:'forwards'})
        .finished.finally(()=>{
          chip.remove();
          root.hidden=true;
          reopenCartIfNeeded();
        });
      return;
    }

    const from=chip.getBoundingClientRect();
    const to=cart.getBoundingClientRect();
    const dx=to.left+to.width/2-(from.left+from.width/2);
    const dy=to.top+to.height/2-(from.top+from.height/2);

    chip.animate(
      [
        {transform:'translate3d(0,0,0) scale(1)',opacity:1},
        {transform:'translate3d('+dx+'px,'+dy+'px,0) scale(.10)',opacity:.12}
      ],
      {duration:760,easing:'cubic-bezier(.45,0,.2,1)',fill:'forwards'}
    ).finished.finally(()=>{
      chip.remove();
      root.hidden=true;
      pulseCart();
      reopenCartIfNeeded();
    });
  }

  function reopenCartIfNeeded(){
    if(!openedFromCart)return;
    const surface=openedSurface;
    openedFromCart=false;
    openedSurface='';

    window.setTimeout(()=>{
      if(surface==='drawer'){
        const drawer=document.querySelector('cart-drawer');
        const cart=document.querySelector('#cart-icon-bubble');
        if(drawer?.open)drawer.open(cart);
      }else if(surface==='notification'){
        const notification=document.querySelector('cart-notification');
        if(notification?.open)notification.open();
      }
    },260);
  }

  function pulseCart(){
    const cart=document.querySelector('#cart-icon-bubble');
    if(!cart)return;
    cart.classList.remove('sp-cart-pulse');
    void cart.offsetWidth;
    cart.classList.add('sp-cart-pulse');
    setTimeout(()=>cart.classList.remove('sp-cart-pulse'),700);
  }
})();